module.exports = __webpack_public_path__ + "img/img-personal-data.b927e225.svg";